import { css, cx } from '@emotion/css';


/* Colours and fonts are left to the page: a poster is nearly always a rendered image, and the
   fallbacks behind it are a last resort that should look like the rest of the site.
   flexShrink because the poster is a flex item in the carousel and grid layouts, and its own
   'overflow:hidden' zeroes the automatic minimum size a flex item would otherwise get - without
   this the posters are squeezed well under their width and their right hand sides are cropped. */
const posterStyle = css({
	width: 300,
	height: 375,
	textAlign: 'center',
	overflow: 'hidden',
	flexShrink: 0,
});

export function Poster(P:{children})
{
	return (
		<div class={cx('capture',posterStyle)}>
			{ P.children }
		</div>
	);
}

export function maxTextLines(maxLines:number) 
{
	/* 
		In time should be able to use unprefixed line-clamp. 
		See: https://caniuse.com/?search=line-clamp for progress 
	*/
	const limitProperties = maxLines==1 ? { whiteSpace: 'nowrap' } : {
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: `${maxLines}`
	};

	return {
		...limitProperties,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	};
}

